import { AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { Building } from '../../types';
import { BuildingsAction } from '../../types/actions';
import { get } from './requests';

export enum EndpointType {
  all = 'all',
  landlord = 'landlord',
}

export function getBuildingsRequest(
  filter: string,
  type: EndpointType,
): Promise<AxiosResponse<Building[]>> {
  const url =
    type === EndpointType.landlord
      ? '/api/v1/buildings/landlord-autocomplete'
      : '/api/v1/buildings';

  return get<Building[]>(
    url,
    { filter },
    {
      'API-key': 'deda6c4f671bfda934878c82e00a7f7b',
    },
  );
}

export const GET_BUILDINGS_REQUEST = 'getBuildings/request';
export const GET_BUILDINGS_SUCCESS = 'getBuildings/success';
export const GET_BUILDINGS_FAILURE = 'getBuildings/failure';

export const getBuildingsAction = createAsyncAction(
  GET_BUILDINGS_REQUEST,
  GET_BUILDINGS_SUCCESS,
  GET_BUILDINGS_FAILURE,
)<void, Building[], Error>();

export const getBuildings = (value: string, type: EndpointType) =>
  async (dispatch: Dispatch<BuildingsAction>) => {
    try {
      dispatch(getBuildingsAction.request());
      const result: AxiosResponse<Building[]> = await getBuildingsRequest(value, type);
      dispatch(getBuildingsAction.success(result.data));
    } catch (error) {
      dispatch(getBuildingsAction.failure(error as Error));
    }
  };

export const CLEAR_BUILDINGS = 'clearBuildings';
export const clearBuildings = createAction(CLEAR_BUILDINGS);
